(function () {
    'use strict';

    angular.module('app')
        .factory('Xogo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "xogo";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();
